// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__aZeIs","banner_icon":"banner_banner_icon__G58XS","banner_title":"banner_banner_title__JkCI0"};